/**
 * Extends a relative route with the host.
 *
 * @param path: Relative path with leading slash (like: '/sub-route')
 *
 */
export const createRoute = (path: string) => `${process.env.PUBLIC_URL}${path}`;
